export default __webpack_public_path__ + "static/media/slider_1.84ff4d75.png";